// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Router from "next/router";
import * as MediaQuery$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/hooks/MediaQuery.mjs";
import * as NextImage$PorterinFeature from "../../../../ui/components/NextImage.mjs";
import * as CityContext$PorterinFeature from "../../../../contexts/city-context/CityContext.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../core/constants/GAEventsConstants.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as CategorySelectorModuleScss from "../styles/CategorySelector.module.scss";

var styles = CategorySelectorModuleScss;

function CategorySelectCmp(Props) {
  var category_details = Props.category_details;
  var onCategorySelect = Props.onCategorySelect;
  var arrow_icon = Props.arrow_icon;
  var citySelectedContext = CityContext$PorterinFeature.useCitySelectedContext(undefined);
  var isDesktop = MediaQuery$PorterinUtils.useMediaQuery("(min-width: 560px)");
  var router = Router.useRouter();
  return React.createElement("div", {
              className: styles["category-select-container"],
              onClick: (function (param) {
                  PublishEventsHelper$PorterinFeature.publishEvents(citySelectedContext.category, GAEventsConstants$PorterinFeature.gaEstimateCategoryCardAction + category_details.service_type, category_details.service_type);
                  PublishEventsHelper$PorterinFeature.publishFareEstimateCategoryCardEvent(citySelectedContext.category, category_details.text, category_details.text);
                  if (isDesktop) {
                    return Curry._1(onCategorySelect, category_details.service_type);
                  } else {
                    router.push(category_details.link + citySelectedContext.query_params);
                    return ;
                  }
                })
            }, React.createElement("div", {
                  className: styles["category-image-text"]
                }, React.createElement("div", {
                      className: styles["category-image"]
                    }, React.createElement(NextImage$PorterinFeature.make, {
                          src: category_details.image.path,
                          height: 80.0,
                          width: 80.0,
                          quality: 100.0,
                          alt: category_details.image.alt_text
                        })), React.createElement("div", {
                      className: styles["category-text"]
                    }, category_details.text)), React.createElement("div", {
                  className: styles["arrow-icon"]
                }, React.createElement(NextImage$PorterinFeature.make, {
                      src: arrow_icon.path,
                      height: 40.0,
                      width: 40.0,
                      quality: 100.0,
                      alt: arrow_icon.alt_text
                    })));
}

var make = CategorySelectCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
